import React from 'react';

export const MarkdownEditor = React.lazy(() => import('./MarkdownEditor'));
